import {
  addStepsData as PersonalAddStepsData,
  setStep as PersonalSetStep,
} from "app/lib/store/slices/steps/personalDetails";
import {
  addStepsData as employmentAddStepsData,
  setStep as employmentSetStep,
} from "app/lib/store/slices/steps/employmentDetails";

import {
  addStepsData as incomeAddStepsData,
  setStep as incomeSetStep,
} from "app/lib/store/slices/steps/incomeDetails";

import {
  addStepsData as assetLiabilityAddStepsData,
  setStep as assetLiabilitySetStep,
} from "app/lib/store/slices/steps/assetsLiabilities";

// joint Application

import {
  setStep as JointPersonalSetStep,
  addStepsData as JointPersonalAddStepsData,
} from "app/lib/store/slices/steps/jointpersonalDetails";

import {
  addStepsData as jointEmploymentAddStepsData,
  setStep as jointEmploymentSetStep,
} from "app/lib/store/slices/steps/jointemploymentDetails";

import {
  addStepsData as jointIncomeAddStepsData,
  setStep as jointIncomeSetStep,
} from "app/lib/store/slices/steps/jointIncomeDetails";

import {
  addStepsData as jointAssetLiabilityAddStepsData,
  setStep as jointAssetLiabilitySetStep,
} from "app/lib/store/slices/steps/jointAssetsLiabilities";

import { normalizeSavedIncomes } from "app/utils/normalizeIncome";

const extractSavedIds = (
  applicant: any,
  vehicleDetail: any,
  loanApplication: any,
  applicationType: string,
  applicationReferenceNumber: string
) => {
  const savedIds: Record<string, string | null> = {};
  const applicantAbj = applicant[0];
  if (applicationType !== "joint") {
    if (applicantAbj?.id) savedIds["applicantID"] = applicantAbj.id;
    if (applicantAbj?.employment?.id)
      savedIds["employmentID"] = applicantAbj?.employment.id;
    if (applicantAbj.incomes.length > 0) {
      savedIds["incomeIDs"] =
        applicantAbj?.incomes?.map((income: any) => income.id) || [];
    }
    if (applicantAbj.liabilities) {
      savedIds["liabilitieID"] = applicantAbj?.liabilities?.id;
    }
    if (applicantAbj.linkUrl) {
      savedIds["bankDocLink"] = applicantAbj?.linkUrl;
    }
    if (vehicleDetail?.id) savedIds["vehicleDetailID"] = vehicleDetail.id;
    if (loanApplication?.id) savedIds["loanApplicationID"] = loanApplication.id;
    if (applicationReferenceNumber)
      savedIds["applicationReferenceNumber"] = applicationReferenceNumber;
  } else {
    const sortedApplicants = [
      ...applicant?.filter((a: any) => a.isPrimary),
      ...applicant?.filter((a: any) => !a.isPrimary),
    ];
    const mainApplicant = sortedApplicants?.[0];
    const childApplicant = sortedApplicants?.[1];
    if (mainApplicant?.id) savedIds["applicantID"] = mainApplicant.id;
    if (childApplicant?.id) savedIds["secondApplicantID"] = childApplicant.id;
    if (mainApplicant?.employment?.id)
      savedIds["employmentID"] = mainApplicant?.employment?.id;
    if (childApplicant?.employment?.id)
      savedIds["secondEmploymentID"] = childApplicant?.employment?.id;
    if (vehicleDetail?.id) savedIds["vehicleDetailID"] = vehicleDetail.id;
    if (loanApplication?.id) savedIds["loanApplicationID"] = loanApplication.id;
    if (applicationReferenceNumber)
      savedIds["applicationReferenceNumber"] = applicationReferenceNumber;
    if (mainApplicant?.incomes.length > 0) {
      savedIds["incomeIDs"] =
        mainApplicant?.incomes?.map((income: any) => income.id) || [];
    }
    if (childApplicant?.incomes?.length > 0) {
      savedIds["secondIncomeIDs"] =
        childApplicant?.incomes?.map((income: any) => income.id) || [];
    }
    if (mainApplicant?.liabilities?.id) {
      savedIds["liabilitieID"] = mainApplicant?.liabilities?.id;
    }
    if (childApplicant?.liabilities?.id) {
      savedIds["secondliabilitieID"] = childApplicant?.liabilities?.id;
    }
    if (mainApplicant?.linkUrl) {
      savedIds["bankDocLink"] = mainApplicant?.linkUrl;
    }
    if (childApplicant?.linkUrl) {
      savedIds["secondBankDocLink"] = childApplicant?.linkUrl;
    }
  }
  return savedIds;
};

const extractVehicleDetails = (vehicleDetail: any) => {
  return {
    make: vehicleDetail?.make,
    model: vehicleDetail?.model,
    year: vehicleDetail?.year,
    purchaseFrom: vehicleDetail?.purchaseFrom,
    vehicleCondition: vehicleDetail?.vehicleCondition,
    makeId: vehicleDetail?.makeId,
    id: vehicleDetail?.id,
    price: vehicleDetail?.price,
    vinNumber: vehicleDetail?.vinNumber || "",
    licensePlateNumber: vehicleDetail?.licensePlateNumber || "",
    manuallyModel: false,
    isCarManuallyModel: false,
  };
};

const extractLoanApplicationData = (loanApplication: any) => {
  if (!loanApplication) {
    return {};
  }
  return {
    applicationType: loanApplication.applicationType,
    loanType: loanApplication.loanType,
    loanFor: loanApplication.loanFor,
    rateType: loanApplication.rateType,
    loanAmount: loanApplication.loanAmount,
    loanTerm: loanApplication.loanTerm,
    balloonPayment: loanApplication.balloonPayment,
    refinanceAmount: loanApplication.refinanceAmount,
    ...(loanApplication.coApplicantRelationship
      ? { coApplicantRelationship: loanApplication.coApplicantRelationship }
      : {}),
    ...(loanApplication.coApplicantsSameAddress != null
      ? { coApplicantsSameAddress: loanApplication.coApplicantsSameAddress }
      : {}),
  };
};

const extractApplicantData = (applicant: any) => {
  return {
    firstName: applicant?.firstName,
    lastName: applicant?.lastName,
    dateOfBirth: applicant?.dateOfBirth,
    email: applicant?.email,
    phoneNumber: applicant?.phoneNumber,
    numberOfDependents: applicant?.numberOfDependents,
    maritalStatus: applicant?.maritalStatus,
    address: applicant?.address,
    employment: applicant?.employment,
    incomes: Array.isArray(applicant?.incomes)
      ? applicant.incomes.map((income: any) => ({
          type: income?.type,
          amount: income?.amount,
          frequency: income?.frequency,
          id: income?.id,
        }))
      : [],
    // expense: applicant?.expense,
  };
};

const extractPersonalInfoSteps = (applicant: any) => {
  return {
    formOne: {
      firstName: applicant?.firstName,
      middleName: applicant?.middleName ?? "",
      lastName: applicant?.lastName,
      borrower: applicant?.borrower ?? true,
    },
    formTwo: {
      knownByOtherName: applicant?.knownByOtherName,
      dateOfBirth: applicant?.dateOfBirth,
      otherNameDesc: applicant?.otherNameDesc || "",
      drivingLicense: applicant?.drivingLicense,
    },
    formThree: {
      phoneNumber: applicant?.phoneNumber,
      landline: applicant?.landline,
      workNumber: applicant?.workNumber,
      email: applicant?.email,
      preferredMethodOfContact: applicant?.preferredMethodOfContact,
    },
    formFour: {
      visaStatus: applicant?.visaStatus,
      maritalStatus: applicant?.maritalStatus,
      numberOfDependents: applicant?.numberOfDependents,
      address: applicant?.address,
      ...(applicant?.visaNumber && { visaNumber: applicant.visaNumber }),
      ...(applicant?.numberOfDependents > 0 &&
        applicant?.numberOfDependents > 0 && {
          dependentAges: (applicant?.dependentAges || "").split(","),
        }),
    },
    formFive: {
      street: applicant?.mailingAddress?.street || applicant?.address?.street,
      housingStatus: applicant?.mailingAddress?.housingStatus,
      methodofcontact: applicant?.mailingAddress.methodofcontact,
      state: applicant?.mailingAddress?.state || applicant?.address?.state,
      monthsOfStay: applicant?.mailingAddress?.monthsOfStay,
      yearsOfStay: applicant?.mailingAddress?.yearsOfStay,
      postCode:
        applicant?.mailingAddress?.postCode || applicant?.address?.postCode,
      sameMailingAddress: applicant?.sameMailingAddress,
    },
  };
};
const extractEmploymentSteps = (employment: any) => {
  const secondJobExists =
    employment?.secondJob &&
    Object.values(employment.secondJob).some(
      (val) => val !== null && val !== ""
    );
  const previousemployerExists =
    employment?.previousEmployer &&
    Object.values(employment.previousEmployer).some(
      (val) => val !== null && val !== ""
    );
  return {
    formOne: {
      currentEmployment:
        employment?.currentEmployment || employment?.employmentType,
      currentOccupation: employment?.currentOccupation,
      employerName: employment?.employerName,
      abn: employment?.abn,
      employerAddress: employment?.employerAddress,
      employerPhoneNumber: employment?.employerPhoneNumber,
    },
    formTwo: {
      employmentType: employment?.employmentType === "full-time" ? "yes" : "no",
      joiningDate: employment?.joiningDate,
      previousemployer: previousemployerExists ? "yes" : "no",
    },
    formThree: {
      jobTitle: employment?.previousEmployer?.jobTitle,
      employerName: employment?.previousEmployer?.employerName,
      street: employment?.previousEmployer?.street,
      state: employment?.previousEmployer?.state,
      postCode: employment?.previousEmployer?.postCode,
      secondjob: secondJobExists ? "yes" : "no",
      startDate: employment?.previousEmployer?.startDate,
      endDate: employment?.previousEmployer?.endDate,
    },
    formFour: {
      occupation: employment?.secondJob?.occupation,
      employerPhoneNumber: employment?.secondJob?.employerPhoneNumber,
      street: employment?.secondJob?.street,
      state: employment?.secondJob?.state,
      postCode: employment?.secondJob?.postCode,
      secondjob: secondJobExists ? "yes" : "no",
      startDate: employment?.secondJob?.startDate,
      employmentType: employment?.secondJob?.employmentType,
    },
  };
};

export const extractAssetsLiabilitiesSteps = (assetLiabilityData: any) => {
  const documents = assetLiabilityData?.documents ?? [];

  const getDocByType = (type: string) =>
    documents.find((doc: any) => doc.type === type);

  const passportDoc = getDocByType("passport");
  const visaDoc = getDocByType("visa");
  const birthCertDoc = getDocByType("birth_or_citizenship_certificate");
  const medicareDoc = getDocByType("medicare_card");
  const frontDLDoc = getDocByType("front_driver_license");
  const backDLDoc = getDocByType("back_driver_license");

  const hasBirthMedicareDoc = birthCertDoc || medicareDoc;
  const hasDriverLicense = frontDLDoc || backDLDoc;

  return {
    formOne: {
      realeStateType:
        Array.isArray(assetLiabilityData?.realStates) &&
        assetLiabilityData?.realStates?.length > 0
          ? "yes"
          : "no",
      superannuationType:
        Array.isArray(assetLiabilityData?.superannuations) &&
        assetLiabilityData?.superannuations?.length > 0
          ? "yes"
          : "no",
      realState: Array.isArray(assetLiabilityData?.realStates)
        ? assetLiabilityData.realStates.map((item: any) => ({
            ...item,
            ...(item.id && { dbId: item.id }),
          }))
        : [],
      superannuation: Array.isArray(assetLiabilityData?.superannuations)
        ? assetLiabilityData.superannuations.map((item: any) => ({
            ...item,
            ...(item.id && { dbId: item.id }),
          }))
        : [],
    },
    formTwo: {
      savingAndInvestmentsType:
        Array.isArray(assetLiabilityData?.savingInvestments) &&
        assetLiabilityData.savingInvestments.length > 0
          ? "yes"
          : "no",
      otherAssetsType:
        Array.isArray(assetLiabilityData?.otherAssets) &&
        assetLiabilityData.otherAssets.length > 0
          ? "yes"
          : "no",
      savingAndInvestments: Array.isArray(assetLiabilityData?.savingInvestments)
        ? assetLiabilityData.savingInvestments.map((item: any) => ({
            ...item,
            ...(item.id && { dbId: item.id }),
          }))
        : [],
      otherAssets: Array.isArray(assetLiabilityData?.otherAssets)
        ? assetLiabilityData.otherAssets.map((item: any) => ({
            ...item,
            ...(item.id && { dbId: item.id }),
          }))
        : [],
    },
    formThree: {
      existingMortgageType:
        Array.isArray(assetLiabilityData?.existingMortgages) &&
        assetLiabilityData.existingMortgages.length > 0
          ? "yes"
          : "no",
      carloanType:
        Array.isArray(assetLiabilityData?.carLoans) &&
        assetLiabilityData.carLoans.length > 0
          ? "yes"
          : "no",
      existingMortgage: Array.isArray(assetLiabilityData?.existingMortgages)
        ? assetLiabilityData.existingMortgages.map((item: any) => ({
            ...item,
            ...(item.id && { dbId: item.id }),
          }))
        : [],
      carLoan: Array.isArray(assetLiabilityData?.carLoans)
        ? assetLiabilityData.carLoans.map((item: any) => ({
            ...item,
            ...(item.id && { dbId: item.id }),
          }))
        : [],
    },
    formFour: {
      otherliabilitiesType:
        Array.isArray(assetLiabilityData?.otherLiabilities) &&
        assetLiabilityData?.otherLiabilities?.length > 0
          ? "yes"
          : "no",
      otherLiabilities: Array.isArray(assetLiabilityData?.otherLiabilities)
        ? assetLiabilityData.otherLiabilities.map((item: any) => ({
            ...item,
            ...(item.id && { dbId: item.id }),
          }))
        : [],
    },
    ...(!hasBirthMedicareDoc && {
      passportImage: passportDoc?.url ?? "",
    }),
    IsvalidPassport: hasBirthMedicareDoc,
    ...(hasBirthMedicareDoc && {
      isValidPassportImages: {
        backImage: birthCertDoc?.url ?? "",
        frontImage: medicareDoc?.url ?? "",
      },
    }),
    ...(hasDriverLicense && {
      driverlicenseimages: {
        frontImage: frontDLDoc?.url ?? "",
        backImage: backDLDoc?.url ?? "",
      },
    }),
    ...(passportDoc?.url && visaDoc?.url
      ? {
          visaAndPassportimages: {
            passportImage: passportDoc?.url ?? "",
            visaImage: visaDoc?.url ?? "",
          },
        }
      : {}),
    bankStatement:
      Array.isArray(documents) &&
      documents.some((doc) => doc.type === "bank_statement")
        ? documents
            .filter((doc: any) => doc.type === "bank_statement" && doc.url)
            .map((doc: any) => doc.url)
        : [],
  };
};
// if the Application Type is not joint

export const handleStepNavigation = (
  step: string,
  applicant: any,
  employment: any,
  incomesData: any,
  dispatch: Function,
  navigate: Function
) => {
  const syncAllStepData = () => {
    // Personal Info
    if (applicant?.length) {
      dispatch(PersonalAddStepsData(extractPersonalInfoSteps(applicant[0])));
      let infoStep = applicant[0]?.step ?? 0;
      if (infoStep === 5) {
        infoStep = 4;
      }
      dispatch(PersonalSetStep(infoStep));
    }

    // Employment Info
    if (employment) {
      dispatch(employmentAddStepsData(extractEmploymentSteps(employment)));
      dispatch(employmentSetStep(employment?.step ?? 1));
    }

    // Income Info
    if (incomesData?.length) {
      const formattedIncomes = normalizeSavedIncomes(incomesData);
      dispatch(incomeAddStepsData({ income: formattedIncomes }));
      dispatch(incomeSetStep(1));
    }

    // Asset & Liability Info
    if (
      (step === "assetsLiability" || step === "signature") &&
      applicant?.[0]
    ) {
      const applicantData = applicant[0];

      dispatch(
        assetLiabilityAddStepsData(extractAssetsLiabilitiesSteps(applicantData))
      );

      const stepChecks = [
        Array.isArray(applicantData.realStates) &&
          applicantData.realStates.length > 0,
        Array.isArray(applicantData.superannuations) &&
          applicantData.superannuations.length > 0,

        Array.isArray(applicantData.savingInvestments) &&
          applicantData.savingInvestments.length > 0,
        Array.isArray(applicantData.otherAssets) &&
          applicantData.otherAssets.length > 0,

        Array.isArray(applicantData.existingMortgages) &&
          applicantData.existingMortgages.length > 0,

        Array.isArray(applicantData.carLoans) &&
          applicantData.carLoans.length > 0,

        Array.isArray(applicantData.otherLiabilities) &&
          applicantData.otherLiabilities.length > 0,
        applicantData?.documents?.some((doc: any) => doc.type === "passport"), // formFive
        applicantData?.documents?.some(
          // formSix
          (doc: any) =>
            doc.type === "front_driver_license" ||
            doc.type === "back_driver_license"
        ),
        applicantData?.documents?.some(
          (doc: any) => doc.type === "bank_statement"
        ),
        applicantData?.documents?.some(
          // formSix
          (doc: any) => doc.type === "visa" && doc.type === "passport"
        ),
      ];

      const hasSteps = [
        stepChecks[0] || stepChecks[0], // formOne
        stepChecks[1] || stepChecks[1], // formTwo
        stepChecks[2], // formThree
        stepChecks[3], // formThree
        stepChecks[4], // formFour
        stepChecks[5], // formFive (passport)
        stepChecks[6], // formSix (birth cert / medicare)
        stepChecks[7], // formSix (bank_statement)
      ];
      const maxStep = hasSteps.lastIndexOf(true);
      const stepToSet = maxStep >= 0 ? maxStep : 0;
      dispatch(assetLiabilitySetStep(stepToSet));
    }
  };

  syncAllStepData();

  switch (step) {
    case "personalInfo":
      setTimeout(() => navigate(`/personal-details`), 300);
      break;

    case "employment":
      setTimeout(() => navigate(`/employment-details`), 300);
      break;

    case "income":
      setTimeout(() => navigate(`/income-details`), 300);
      break;

    case "assetsLiability":
      setTimeout(() => navigate(`/assets-liabilities`), 300);
      break;
    case "signature":
      setTimeout(() => navigate(`/assets-liabilities`), 300);
      break;

    default:
      console.warn("Unknown step:", step);
      break;
  }
};

// ---------------------- if the Application Type is joint ------------------

const extractJointPersonalInfoSteps = (
  applicantOne: any,
  applicantTwo: any
) => {
  return {
    formOne: {
      yourDetails: {
        firstName: applicantOne?.firstName,
        middleName: applicantOne?.middleName ?? "",
        lastName: applicantOne?.lastName,
        borrower: applicantOne?.borrower ?? true,
      },
      coBorrowerDetails: {
        firstName: applicantTwo?.firstName,
        middleName: applicantTwo?.middleName ?? "",
        lastName: applicantTwo?.lastName,
        borrower: applicantTwo?.borrower ?? true,
      },
    },

    formTwo: {
      yourDetails: {
        knownByOtherName: applicantOne.knownByOtherName,
        dateOfBirth: applicantOne.dateOfBirth,
        otherNameDesc: applicantOne.otherNameDesc,
        drivingLicense: applicantOne.drivingLicense,
      },
      coBorrowerDetails: {
        knownByOtherName: applicantTwo.knownByOtherName,
        dateOfBirth: applicantTwo.dateOfBirth,
        otherNameDesc: applicantTwo.otherNameDesc,
        drivingLicense: applicantTwo.drivingLicense,
      },
    },
    formThree: {
      yourDetails: {
        phoneNumber: applicantOne.phoneNumber,
        landline: applicantOne.landline,
        workNumber: applicantOne.workNumber,
        email: applicantOne.email,
        preferredMethodOfContact: applicantOne.preferredMethodOfContact,
      },
      coBorrowerDetails: {
        phoneNumber: applicantTwo.phoneNumber,
        landline: applicantTwo.landline,
        workNumber: applicantTwo.workNumber,
        email: applicantTwo.email,
        preferredMethodOfContact: applicantTwo.preferredMethodOfContact,
      },
    },
    formFour: {
      yourDetails: {
        visaStatus: applicantOne.visaStatus,
        maritalStatus: applicantOne.maritalStatus,
        numberOfDependents: applicantOne.numberOfDependents,
        address: applicantOne?.address,
        ...(applicantOne?.visaNumber && {
          visaNumber: applicantOne.visaNumber,
        }),
        ...(applicantOne?.numberOfDependents > 0 &&
          applicantOne?.numberOfDependents > 0 && {
            // dependentAges: applicantOne.dependentAges.split(","),
            dependentAges: (applicantOne?.dependentAges || "").split(","),
          }),
      },
      coBorrowerDetails: {
        visaStatus: applicantTwo.visaStatus,
        maritalStatus: applicantTwo.maritalStatus,
        numberOfDependents: applicantTwo.numberOfDependents,
        address: applicantTwo?.address,
        ...(applicantTwo?.visaNumber && {
          visaNumber: applicantTwo.visaNumber,
        }),
        ...(applicantTwo?.numberOfDependents > 0 &&
          applicantTwo?.numberOfDependents > 0 && {
            // dependentAges: applicantTwo.dependentAges.split(","),
            dependentAges: (applicantTwo?.dependentAges || "").split(","),
          }),
      },
    },

    formFive: {
      yourDetails: {
        street:
          applicantOne?.mailingAddress?.street || applicantOne?.address?.street,
        housingStatus: applicantOne?.mailingAddress?.housingStatus,
        methodofcontact: applicantOne?.mailingAddress?.methodofcontact,
        state:
          applicantOne?.mailingAddress?.state || applicantOne?.address?.state,
        monthsOfStay: applicantOne?.mailingAddress?.monthsOfStay,
        yearsOfStay: applicantOne?.mailingAddress?.yearsOfStay,
        postCode:
          applicantOne?.mailingAddress?.postCode ||
          applicantOne?.address?.postCode,
        sameMailingAddress: applicantOne?.sameMailingAddress,
      },
      coBorrowerDetails: {
        street:
          applicantTwo?.mailingAddress?.street || applicantTwo?.address?.street,
        housingStatus: applicantTwo?.mailingAddress?.housingStatus,
        methodofcontact: applicantTwo?.mailingAddress?.methodofcontact,
        state:
          applicantTwo?.mailingAddress?.state || applicantTwo?.address?.state,
        monthsOfStay: applicantTwo?.mailingAddress?.monthsOfStay,
        yearsOfStay: applicantTwo?.mailingAddress?.yearsOfStay,
        postCode:
          applicantTwo?.mailingAddress?.postCode ||
          applicantTwo?.address?.postCode,
        sameMailingAddress: applicantTwo?.sameMailingAddress,
      },
    },
  };
};

const jointExtractEmploymentSteps = (
  employmentOne: any,
  employmentTwo: any
) => {
  const yourSecondJobExists =
    employmentOne?.secondJob &&
    Object.values(employmentOne.secondJob).some(
      (val) => val !== null && val !== ""
    );
  const coSecondJobExists =
    employmentTwo?.secondJob &&
    Object.values(employmentTwo.secondJob).some(
      (val) => val !== null && val !== ""
    );
  const yourPreviousemployerExists =
    employmentTwo?.previousEmployer &&
    Object.values(employmentTwo.previousEmployer).some(
      (val) => val !== null && val !== ""
    );
  const coPreviousemployerExists =
    employmentTwo?.previousEmployer &&
    Object.values(employmentTwo.previousEmployer).some(
      (val) => val !== null && val !== ""
    );
  return {
    formOne: {
      yourDetails: {
        currentEmployment:
          employmentOne.currentEmployment || employmentOne?.employmentType,
        currentOccupation: employmentOne.currentOccupation,
        employerName: employmentOne.employerName,
        abn: employmentOne.abn,
        employerAddress: employmentOne.employerAddress,
        employerPhoneNumber: employmentOne.employerPhoneNumber,
      },
      coBorrowerDetails: {
        currentEmployment:
          employmentTwo.currentEmployment || employmentTwo?.employmentType,
        currentOccupation: employmentTwo.currentOccupation,
        employerName: employmentTwo.employerName,
        abn: employmentTwo.abn,
        employerAddress: employmentTwo.employerAddress,
        employerPhoneNumber: employmentTwo.employerPhoneNumber,
      },
    },
    formTwo: {
      yourDetails: {
        employmentType:
          employmentOne?.employmentType === "full-time" ? "yes" : "no",
        joiningDate: employmentOne.joiningDate,
        previousemployer: yourPreviousemployerExists ? "yes" : "no",
      },
      coBorrowerDetails: {
        employmentType:
          employmentTwo.employmentType === "full-time" ? "yes" : "no",
        joiningDate: employmentTwo.joiningDate,
        previousemployer: coPreviousemployerExists ? "yes" : "no",
      },
    },
    formThree: {
      yourDetails: {
        jobTitle: employmentOne?.previousEmployer?.jobTitle,
        employerName: employmentOne?.previousEmployer?.employerName,
        street: employmentOne?.previousEmployer?.street,
        state: employmentOne?.previousEmployer?.state,
        postCode: employmentOne?.previousEmployer?.postCode,
        secondjob: yourSecondJobExists ? "yes" : "no",
        startDate: employmentOne?.previousEmployer?.startDate,
        endDate: employmentOne?.previousEmployer?.endDate,
      },
      coBorrowerDetails: {
        jobTitle: employmentTwo?.previousEmployer?.jobTitle,
        employerName: employmentTwo?.previousEmployer?.employerName,
        street: employmentTwo?.previousEmployer?.street,
        state: employmentTwo?.previousEmployer?.state,
        postCode: employmentTwo?.previousEmployer?.postCode,
        secondjob: coSecondJobExists ? "yes" : "no",
        startDate: employmentTwo?.previousEmployer?.startDate,
        endDate: employmentTwo?.previousEmployer?.endDate,
      },
    },
    formFour: {
      yourDetails: {
        occupation: employmentOne?.secondJob?.occupation,
        employerPhoneNumber: employmentOne?.secondJob?.employerPhoneNumber,
        street: employmentOne?.secondJob?.street,
        state: employmentOne?.secondJob?.state,
        postCode: employmentOne?.secondJob?.postCode,
        secondjob: yourSecondJobExists ? "yes" : "no",
        startDate: employmentOne?.secondJob?.startDate,
        employmentType: employmentOne?.secondJob?.employmentType,
      },
      coBorrowerDetails: {
        occupation: employmentTwo?.secondJob?.occupation,
        employerPhoneNumber: employmentTwo?.secondJob?.employerPhoneNumber,
        street: employmentTwo?.secondJob?.street,
        state: employmentTwo?.secondJob?.state,
        postCode: employmentTwo?.secondJob?.postCode,
        secondjob: coSecondJobExists ? "yes" : "no",
        startDate: employmentTwo?.secondJob?.startDate,
        employmentType: employmentTwo?.secondJob?.employmentType,
      },
    },
  };
};

export const jointExtractAssetLiabilitySteps = (
  assetLiabilityDataOne: any,
  assetLiabilityDataTwo: any
) => {
  const yourdocuments = assetLiabilityDataOne?.documents ?? [];
  const codocuments = assetLiabilityDataTwo?.documents ?? [];

  const yourGetDocByType = (type: string) =>
    yourdocuments.find((doc: any) => doc.type === type);

  const coGetDocByType = (type: string) =>
    codocuments.find((doc: any) => doc.type === type);
  // passport
  const yourPassportDoc = yourGetDocByType("passport");
  const coPassportDoc = coGetDocByType("passport");
  // visa
  const yourVisa = yourGetDocByType("visa");
  const coVisa = coGetDocByType("visa");

  const yourBirthCertDoc = yourGetDocByType("birth_or_citizenship_certificate");
  const yourMedicareDoc = yourGetDocByType("medicare_card");
  const coBirthCertDoc = coGetDocByType("birth_or_citizenship_certificate");
  const coMedicareDoc = coGetDocByType("medicare_card");

  const yourFrontDLDoc = yourGetDocByType("front_driver_license");
  const yourBackDLDoc = yourGetDocByType("back_driver_license");
  const coFrontDLDoc = coGetDocByType("front_driver_license");
  const coBackDLDoc = coGetDocByType("back_driver_license");

  const hasYourBirthMedicareDoc = yourBirthCertDoc || yourMedicareDoc;
  const hasCoBirthMedicareDoc = coBirthCertDoc || coMedicareDoc;

  const hasVisaPassport =
    (yourPassportDoc?.url && yourVisa?.url) ||
    (coPassportDoc?.url && coVisa?.url);

  return {
    formOne: {
      yourDetails: {
        realeStateType:
          Array.isArray(assetLiabilityDataOne?.realStates) &&
          assetLiabilityDataOne?.realStates?.length > 0
            ? "yes"
            : "no",
        superannuationType:
          Array.isArray(assetLiabilityDataOne?.superannuations) &&
          assetLiabilityDataOne?.superannuations.length > 0
            ? "yes"
            : "no",

        realState: Array.isArray(assetLiabilityDataOne?.realStates)
          ? assetLiabilityDataOne.realStates.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],

        superannuation: Array.isArray(assetLiabilityDataOne?.superannuations)
          ? assetLiabilityDataOne.superannuations.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
      coBorrowerDetails: {
        realeStateType:
          Array.isArray(assetLiabilityDataTwo?.realStates) &&
          assetLiabilityDataTwo?.realStates.length > 0
            ? "yes"
            : "no",
        superannuationType:
          Array.isArray(assetLiabilityDataTwo?.superannuations) &&
          assetLiabilityDataTwo?.superannuations?.length > 0
            ? "yes"
            : "no",
        realState: Array.isArray(assetLiabilityDataTwo?.realStates)
          ? assetLiabilityDataTwo.realStates.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],

        superannuation: Array.isArray(assetLiabilityDataTwo?.superannuations)
          ? assetLiabilityDataTwo.superannuations.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
    },
    formTwo: {
      yourDetails: {
        savingAndInvestmentsType:
          Array.isArray(assetLiabilityDataOne?.savingInvestments) &&
          assetLiabilityDataOne?.savingInvestments?.length > 0
            ? "yes"
            : "no",
        otherAssetsType:
          Array.isArray(assetLiabilityDataOne?.otherAssets) &&
          assetLiabilityDataOne?.otherAssets?.length > 0
            ? "yes"
            : "no",
        savingAndInvestments: Array.isArray(
          assetLiabilityDataOne?.savingInvestments
        )
          ? assetLiabilityDataOne?.savingInvestments?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
        otherAssets: Array.isArray(assetLiabilityDataOne?.otherAssets)
          ? assetLiabilityDataOne?.otherAssets?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
      coBorrowerDetails: {
        savingAndInvestmentsType:
          Array.isArray(assetLiabilityDataTwo?.savingInvestments) &&
          assetLiabilityDataTwo?.savingInvestments?.length > 0
            ? "yes"
            : "no",
        otherAssetsType:
          Array.isArray(assetLiabilityDataTwo?.otherAssets) &&
          assetLiabilityDataTwo?.otherAssets?.length > 0
            ? "yes"
            : "no",
        savingAndInvestments: Array.isArray(
          assetLiabilityDataTwo?.savingInvestments
        )
          ? assetLiabilityDataTwo?.savingInvestments?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
        otherAssets: Array.isArray(assetLiabilityDataTwo?.otherAssets)
          ? assetLiabilityDataTwo?.otherAssets?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
    },
    formThree: {
      yourDetails: {
        existingMortgageType:
          Array.isArray(assetLiabilityDataOne?.existingMortgages) &&
          assetLiabilityDataOne?.existingMortgages.length > 0
            ? "yes"
            : "no",
        carloanType:
          Array.isArray(assetLiabilityDataOne?.carLoans) &&
          assetLiabilityDataOne?.carLoans?.length > 0
            ? "yes"
            : "no",
        existingMortgage: Array.isArray(
          assetLiabilityDataOne?.existingMortgages
        )
          ? assetLiabilityDataOne?.existingMortgages?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
        carLoan: Array.isArray(assetLiabilityDataOne?.carLoans)
          ? assetLiabilityDataOne?.carLoans?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
      coBorrowerDetails: {
        existingMortgageType:
          Array.isArray(assetLiabilityDataTwo?.existingMortgages) &&
          assetLiabilityDataTwo?.existingMortgages?.length > 0
            ? "yes"
            : "no",
        carloanType:
          Array.isArray(assetLiabilityDataTwo?.carLoans) &&
          assetLiabilityDataTwo?.carLoans?.length > 0
            ? "yes"
            : "no",
        existingMortgage: Array.isArray(
          assetLiabilityDataTwo?.existingMortgages
        )
          ? assetLiabilityDataTwo?.existingMortgages?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
        carLoan: Array.isArray(assetLiabilityDataTwo?.carLoans)
          ? assetLiabilityDataTwo?.carLoans?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
    },
    formFour: {
      yourDetails: {
        otherliabilitiesType:
          Array.isArray(assetLiabilityDataOne?.otherLiabilities) &&
          assetLiabilityDataOne?.otherLiabilities?.length > 0
            ? "yes"
            : "no",
        otherLiabilities: Array.isArray(assetLiabilityDataOne?.otherLiabilities)
          ? assetLiabilityDataOne?.otherLiabilities?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
      coBorrowerDetails: {
        otherliabilitiesType:
          Array.isArray(assetLiabilityDataTwo?.otherLiabilities) &&
          assetLiabilityDataTwo.otherLiabilities.length > 0
            ? "yes"
            : "no",
        otherLiabilities: Array.isArray(assetLiabilityDataTwo?.otherLiabilities)
          ? assetLiabilityDataTwo?.otherLiabilities?.map((item: any) => ({
              ...item,
              ...(item.id && { dbId: item.id }),
            }))
          : [],
      },
    },
    ...(yourPassportDoc?.url &&
      !hasYourBirthMedicareDoc && {
        passportImage: yourPassportDoc?.url ?? "",
      }),
    ...(coPassportDoc?.url &&
      !hasCoBirthMedicareDoc && { copassportImage: coPassportDoc?.url ?? "" }),
    ...((yourBirthCertDoc?.url || yourMedicareDoc?.url) && {
      certificate: yourBirthCertDoc?.url ?? "",
      medicareCard: yourMedicareDoc?.url ?? "",
    }),
    ...((coBirthCertDoc?.url || coMedicareDoc?.url) && {
      cocertificate: coBirthCertDoc?.url ?? "",
      comedicareCard: coMedicareDoc?.url ?? "",
    }),

    validAustralianPassport: hasYourBirthMedicareDoc,
    covalidAustralianPassport: hasCoBirthMedicareDoc,
    ...((yourFrontDLDoc?.url ||
      yourBackDLDoc?.url ||
      coFrontDLDoc?.url ||
      coBackDLDoc?.url) && {
      driverlicenseimages: {
        frontImage: yourFrontDLDoc?.url ?? "",
        backImage: yourBackDLDoc?.url ?? "",
        cofrontImage: coFrontDLDoc?.url ?? "",
        cobackImage: coBackDLDoc?.url ?? "",
      },
    }),
    ...(hasVisaPassport && {
      passportVisaimages: {
        passport: yourPassportDoc?.url ?? "",
        visa: yourVisa?.url ?? "",
        copassport: coPassportDoc?.url ?? "",
        covisa: coVisa?.url ?? "",
      },
    }),

    bankStatement:
      Array.isArray(yourdocuments) &&
      yourdocuments.some((doc) => doc.type === "bank_statement")
        ? yourdocuments
            .filter((doc: any) => doc.type === "bank_statement" && doc.url)
            .map((doc: any) => doc.url)
        : [],
    cobankStatement:
      Array.isArray(codocuments) &&
      codocuments.some((doc) => doc.type === "bank_statement")
        ? codocuments
            .filter((doc: any) => doc.type === "bank_statement" && doc.url)
            .map((doc: any) => doc.url)
        : [],
  };
};

const jointExtractApplicantData = (applicationData: any[] = []) => {
  const yourDetails = applicationData[1];
  const coBorrowerDetails = applicationData[0];
  return {
    yourDetails: extractApplicantData(yourDetails),
    Coborrower: extractApplicantData(coBorrowerDetails),
  };
};

const JointApplicationStepNavigation = (
  step: string,
  applicantOne: any,
  applicantTwo: any,
  employmentOne: any,
  employmentTwo: any,
  incomesDataOne: any,
  incomesDataTwo: any,
  dispatch: Function,
  navigate: Function
) => {
  const syncAllStepData = () => {
    // Personal Info
    if (applicantOne && applicantTwo) {
      dispatch(
        JointPersonalAddStepsData(
          extractJointPersonalInfoSteps(applicantOne, applicantTwo)
        )
      );
      let infoStep = applicantOne?.step ?? 0;
      if (infoStep === 5) {
        infoStep = 4;
      }
      dispatch(JointPersonalSetStep(infoStep));
    }

    // Employment Info
    if (employmentOne && employmentTwo) {
      dispatch(
        jointEmploymentAddStepsData(
          jointExtractEmploymentSteps(employmentOne, employmentTwo)
        )
      );
      const step = employmentOne?.step === 2 ? 1 : 0;
      dispatch(jointEmploymentSetStep(step));
    }

    // Income Info
    if (incomesDataOne?.length && incomesDataTwo?.length) {
      const yourFormattedIncomes = normalizeSavedIncomes(incomesDataOne ?? []);
      const coFormattedIncomes = normalizeSavedIncomes(incomesDataTwo ?? []);

      const savedData = {
        yourDetails: yourFormattedIncomes,
        coBorrowerDetails: coFormattedIncomes,
      };

      dispatch(jointIncomeAddStepsData({ income: savedData }));
      dispatch(jointIncomeSetStep(1));
    }

    if (
      (step === "assetsLiability" || step === "signature") &&
      applicantOne &&
      applicantTwo
    ) {
      dispatch(
        jointAssetLiabilityAddStepsData(
          jointExtractAssetLiabilitySteps(applicantOne, applicantTwo)
        )
      );
      const stepChecks = [
        Array.isArray(applicantOne?.realStates) &&
          applicantOne?.realStates?.length > 0,
        Array.isArray(applicantOne?.superannuations) &&
          applicantOne?.superannuations?.length > 0,

        Array.isArray(applicantOne?.savingInvestments) &&
          applicantOne?.savingInvestments?.length > 0,
        Array.isArray(applicantOne?.otherAssets) &&
          applicantOne?.otherAssets?.length > 0,

        Array.isArray(applicantOne?.existingMortgages) &&
          applicantOne?.existingMortgages?.length > 0,

        Array.isArray(applicantOne?.carLoans) &&
          applicantOne?.carLoans?.length > 0,

        Array.isArray(applicantOne?.otherLiabilities) &&
          applicantOne?.otherLiabilities?.length > 0,
        applicantOne?.documents?.some((doc: any) => doc.type === "passport"),
      ];

      const hasSteps = [
        stepChecks[0] || stepChecks[0], // formOne
        stepChecks[1] || stepChecks[1], // formTwo
        stepChecks[2], // formThree
        stepChecks[3], // formThree
        stepChecks[4], // formFour
        stepChecks[5], // formFive (passport)
      ];
      const maxStep = hasSteps.lastIndexOf(true);
      const stepToSet = maxStep >= 0 ? maxStep : 0;

      dispatch(jointAssetLiabilitySetStep(stepToSet));
    }
  };

  syncAllStepData();

  switch (step) {
    case "personalInfo":
      setTimeout(() => navigate(`/joint-personal-details`), 300);
      break;

    case "employment":
      setTimeout(() => navigate(`/joint-employment-details`), 300);
      break;

    case "income":
      setTimeout(() => navigate(`/joint-income-details`), 300);
      break;

    case "assetsLiability":
      setTimeout(() => navigate(`/joint-assets-liabilities`), 400);
      break;
    case "signature":
      setTimeout(() => navigate(`/joint-assets-liabilities`), 400);
      break;
  }
};

export {
  extractSavedIds,
  extractVehicleDetails,
  extractLoanApplicationData,
  extractApplicantData,
  extractPersonalInfoSteps,
  extractEmploymentSteps,
  jointExtractApplicantData,
  JointApplicationStepNavigation,
  extractJointPersonalInfoSteps,
  jointExtractEmploymentSteps,
};
